var _style, _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 171.4 24",
    style: {
      enableBackground: "new 0 0 171.4 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000011005249412410005650000005263069292156353688_);}\n\t.st1{fill:none;stroke:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -34,
    width: 261,
    height: 23.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165927903163906830310000017065612040584745117_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165927903163906830310000017065612040584745117_)"
    }
  }, _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -12.6,
    y1: 23.2,
    x2: 8.3,
    y2: -0.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: -1.7,
    y1: 23.2,
    x2: 19.2,
    y2: -0.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 9.2,
    y1: 23.2,
    x2: 30.1,
    y2: -0.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 20.1,
    y1: 23.2,
    x2: 41,
    y2: -0.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 31,
    y1: 23.2,
    x2: 51.9,
    y2: -0.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 41.9,
    y1: 23.2,
    x2: 62.8,
    y2: -0.4
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 52.8,
    y1: 23.2,
    x2: 73.7,
    y2: -0.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 63.7,
    y1: 23.2,
    x2: 84.6,
    y2: -0.4
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 74.6,
    y1: 23.2,
    x2: 95.5,
    y2: -0.4
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 85.5,
    y1: 23.2,
    x2: 106.4,
    y2: -0.4
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 96.4,
    y1: 23.2,
    x2: 117.3,
    y2: -0.4
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 107.3,
    y1: 23.2,
    x2: 128.2,
    y2: -0.4
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 118.2,
    y1: 23.2,
    x2: 139,
    y2: -0.4
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 129,
    y1: 23.2,
    x2: 149.9,
    y2: -0.4
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 139.9,
    y1: 23.2,
    x2: 160.8,
    y2: -0.4
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 150.8,
    y1: 23.2,
    x2: 171.7,
    y2: -0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxBottom);
export default __webpack_public_path__ + "static/media/box-bottom.b3667caffc157c9fb1e2e5305bef8315.svg";
export { ForwardRef as ReactComponent };